/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：753
 */

module.exports = {
  ImageLibraryItem: "style_ImageLibraryItem__3DbKR",
  selected: "style_selected__2Uupi",
  icon: "style_icon__131o_",
  groupIcon: "style_groupIcon__v261K",
  content: "style_content__XT_DR",
  footer: "style_footer__ApzFD"
}
